module.exports = "<!--Footer -->\n<footer class=\"footer-container\">\n  <div class=\"container-fluid\">\n    <div class=\"row\">\n      <div class=\"col-md-12 col-sm-12\">\n        <div class=\"footer-left\">\n\t\t\t\t\t\t\t<span [innerHtml]=\"copyright\"></span>\n        </div>\n      </div>\n    </div>\n  </div>\n</footer>\n<!--/Footer-->\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/painel/page-footer.component.html
// module id = ./src/app/painel/page-footer.component.html
// module chunks = main